import { SERVICE_WORKER_URL } from '@shared/pwa/utils/registroServiceWorker';
import logger from '@/logger';

/**
 * O script legado monta o `importScripts` com parâmetros da própria URL de registro: quem executar
 * JS na origem pode registrá-lo apontando para um script hospedado numa conta Dengage qualquer e
 * manter um SW malicioso ativo mesmo depois de o XSS ser corrigido. Só o legado é removido: outras
 * aplicações da mesma origem podem ter os próprios service workers.
 */
const TRECHO_SCRIPT_LEGADO = 'dengage';

/**
 * O registro do escopo `/` pode estar no meio da troca, com o legado ainda ativo e o `/sw.js`
 * instalando: desregistrá-lo derrubaria o SW do portal e a assinatura de push junto.
 */
function ehRegistroLegado(registro: ServiceWorkerRegistration): boolean {
  const caminhos = [registro.installing, registro.waiting, registro.active].flatMap(worker =>
    worker ? [new URL(worker.scriptURL).pathname] : []
  );
  return caminhos.some(caminho => caminho.includes(TRECHO_SCRIPT_LEGADO)) && !caminhos.includes(SERVICE_WORKER_URL);
}

/**
 * Desregistra os service workers da Dengage que ainda estiverem no aparelho, em qualquer escopo. O
 * registro do `/sw.js` no escopo `/` substitui o legado do mesmo escopo, mas não os de outros
 * escopos. Nunca lança.
 */
export async function desregistrarServiceWorkerLegado(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registros = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registros.filter(ehRegistroLegado).map(registro => registro.unregister()));
  } catch (error) {
    logger.error.andTrackError(error instanceof Error ? error : new Error(String(error)));
  }
}
